// Colors
export const THEME_DARK_COLOR = "#444554";
export const THEME_OFFSET_COLOR = "#f8f7ed";
export const THEME_SPLASH_COLOR = "#f05451";
export const THEME_BORDER_COLOR = "#bebebe";
export const THEME_SUCCESS_COLOR = "#0A8754";
